import React from 'react';
import { Box, Typography, Container, Stack, Chip, Button } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import Schedule2026 from './Schedule2026';

export default function SchedulePage2026() {
    return (
        <Box sx={{ minHeight: '100vh', backgroundColor: '#FAFAFA' }}>
            {/* Header */}
            <Box
                sx={{
                    background: 'linear-gradient(135deg, #003E7E 0%, #0055A5 60%, #003E7E 100%)',
                    color: 'white',
                    py: { xs: 4, md: 6 },
                    position: 'relative',
                    overflow: 'hidden',
                }}
            >
                <Box sx={{
                    position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
                    background:
                        'radial-gradient(800px circle at 20% 30%, rgba(25,118,210,0.2), transparent 50%),' +
                        'radial-gradient(600px circle at 80% 20%, rgba(156,39,176,0.1), transparent 45%)',
                    pointerEvents: 'none',
                }} />
                <Container maxWidth="lg" sx={{ position: 'relative' }}>
                    <Stack spacing={2} alignItems="center" textAlign="center">
                        <Box
                            component="img"
                            src={process.env.PUBLIC_URL + '/logo192.png'}
                            alt="SDSIC"
                            sx={{ height: 80, width: 'auto' }}
                        />
                        <Stack direction="row" spacing={1} justifyContent="center" flexWrap="wrap">
                            <Chip label="SDSIC" variant="outlined" sx={{ color: 'white', borderColor: 'rgba(255,255,255,0.5)' }} />
                            <Chip label="Spring 2026" sx={{ backgroundColor: '#FF6600', color: 'white' }} />
                            <Chip label="Denver, CO" variant="outlined" sx={{ color: 'white', borderColor: 'rgba(255,255,255,0.5)' }} />
                        </Stack>
                        <Typography
                            variant="h3"
                            sx={{
                                fontWeight: 800,
                                letterSpacing: -0.5,
                                fontSize: { xs: '1.75rem', sm: '2.25rem', md: '2.75rem' },
                            }}
                        >
                            2026 Conference Schedule
                        </Typography>
                        <Typography variant="h6" sx={{ opacity: 0.9, fontWeight: 400 }}>
                            April 13–16, 2026 &bull; Denver, Colorado
                        </Typography>
                        <Button
                            variant="contained"
                            href="https://reg26.sdsconsortium.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                            endIcon={<OpenInNewIcon />}
                            sx={{
                                backgroundColor: '#FF6600',
                                color: 'white',
                                fontSize: '1rem',
                                fontWeight: 600,
                                py: 1.25,
                                px: 3,
                                borderRadius: 2,
                                textTransform: 'none',
                                boxShadow: '0 6px 14px rgba(255, 102, 0, 0.3)',
                                '&:hover': {
                                    backgroundColor: '#e55a00',
                                    transform: 'translateY(-2px)',
                                    boxShadow: '0 10px 18px rgba(255, 102, 0, 0.4)',
                                },
                                transition: 'all 0.3s ease',
                            }}
                        >
                            Register Now — $750
                        </Button>
                    </Stack>
                </Container>
            </Box>

            {/* Schedule */}
            <Schedule2026 />

            {/* Footer CTA */}
            <Box sx={{ py: 5, textAlign: 'center', backgroundColor: '#fff' }}>
                <Container maxWidth="sm">
                    <Typography variant="h5" sx={{ fontWeight: 700, color: '#003E7E', mb: 1.5 }}>
                        Ready to join us?
                    </Typography>
                    <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                        Join member utilities, design firms, contractors, and technology providers for the premier substation design conference.
                    </Typography>
                    <Button
                        variant="contained"
                        href="https://reg26.sdsconsortium.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        endIcon={<OpenInNewIcon />}
                        sx={{
                            backgroundColor: '#FF6600',
                            color: 'white',
                            fontSize: '1.1rem',
                            fontWeight: 600,
                            py: 1.5,
                            px: 4,
                            borderRadius: 2,
                            textTransform: 'none',
                            boxShadow: '0 6px 14px rgba(255, 102, 0, 0.3)',
                            '&:hover': {
                                backgroundColor: '#e55a00',
                                transform: 'translateY(-2px)',
                                boxShadow: '0 10px 18px rgba(255, 102, 0, 0.4)',
                            },
                            transition: 'all 0.3s ease',
                        }}
                    >
                        Register Now
                    </Button>
                    <Typography variant="caption" display="block" color="text.secondary" sx={{ mt: 2 }}>
                        sdsconsortium.com
                    </Typography>
                </Container>
            </Box>
        </Box>
    );
}
